export class ApplicationSettings {
    public banner = new ApplicationSettings.Banner();
}

export namespace ApplicationSettings {
    export class Banner {
        public title : string;
        public content : string;
    }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/applicationSettings.ts